// MicLevelMeter.jsx
// ---------------------------------------------------------------------------
// Phase 4D — Recording Studio Mic Toolkit
//
// Live VU bar (Fix F) driven by useStudioRecorder()'s `level` (0..1) and
// `band` (silent | quiet | good | too-hot). Gives the VA immediate visual
// feedback that their mic is actually capturing energy BEFORE they commit a
// take — the front-line defense against the silent-recording bug.
//
// Props:
//   level  : number  — 0..1 normalized fill width
//   band   : 'silent' | 'quiet' | 'good' | 'too-hot'
//   active : bool     — true while a stream is live (countdown/recording).
//                       When false the meter dims to a resting state.
// ---------------------------------------------------------------------------

import React from 'react';
import './voiceRecorder.css';

const BAND_COPY = {
  silent: 'Silent',
  quiet: 'Quiet',
  good: 'Good',
  'too-hot': 'Too hot',
};

const MicLevelMeter = ({ level = 0, band = 'silent', active = false }) => {
  const pct = Math.round(Math.max(0, Math.min(1, level)) * 100);
  const safeBand = BAND_COPY[band] ? band : 'silent';

  return (
    <div className={`aai-mic-meter${active ? '' : ' aai-mic-meter--idle'}`}>
      <div
        className="aai-mic-meter__track"
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label="Microphone input level"
      >
        <div
          className={`aai-mic-meter__fill aai-mic-meter__fill--${safeBand}`}
          style={{ width: `${active ? pct : 0}%` }}
        />
      </div>
      <span className={`aai-mic-meter__band-label aai-mic-meter__band-label--${safeBand}`}>
        {active ? BAND_COPY[safeBand] : '—'}
      </span>
    </div>
  );
};

export default MicLevelMeter;
